import {Grid} from '@logistics-frontend/blocks'
import {CircularProgress} from '@logistics-frontend/blocks/legacy'
import {useHistory} from '@logistics-frontend/blocks/lpc/react-router'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AsyncStatus, useHistoryListQuery, useOrdersState} from '@yandex-taxi/react-integration-api'
import React, {useEffect, useMemo} from 'react'

import {displayableIsTariff} from '../../shared/utils'
import {useSetBoundsSettings} from '../map-bounds'
import {DisplayableOrder, historyOrderToDisplayable} from '../utils'
import {useClasses} from './classes'
import {OrderList} from './OrderList'
import {OrdersProps} from './utils'

const History: React.FC<OrdersProps> = ({activeOrderID}) => {
  const t = useI18n()
  const {data: orderHistory, status} = useHistoryListQuery()
  const {push} = useHistory()
  const setBoundsSettings = useSetBoundsSettings()
  const {data} = useOrdersState()
  const classes = useClasses()

  const activeOrdersMap = useMemo(
    () =>
      (data?.orders || []).reduce((acc, val) => {
        acc[val.orderid] = true
        return acc
      }, {}),
    [data],
  )

  const history: DisplayableOrder[] | undefined = useMemo(
    () =>
      orderHistory?.orders
        ? orderHistory.orders
            .map(order => historyOrderToDisplayable(order.data))
            .filter(order => !activeOrdersMap[order.id] && displayableIsTariff(order))
        : undefined,
    [orderHistory, activeOrdersMap],
  )

  useEffect(() => {
    if (history && !activeOrderID) {
      push(history[0]?.id)
    }
  }, [activeOrderID, history, push])

  if (status === AsyncStatus.PENDING) {
    return (
      <Grid justify="center" container>
        <CircularProgress color="secondary" size={20} />
      </Grid>
    )
  }

  if (!history || history.length === 0) {
    return <Grid className={classes.title}>{t('order.history.list.empty_placeholder', 'История заказов пуста')}</Grid>
  }

  const onClick = (id: string) => {
    push(id)
    setBoundsSettings({shouldBounds: true})
  }

  return (
    <>
      <Grid className={classes.title}>{t('order.history.list.title', 'История')}</Grid>
      <OrderList activeOrderID={activeOrderID} onClick={onClick} orders={history} />
    </>
  )
}

export default History
